// this reducer is used to store the user's info
// it is not used to store additional user info
// it is also used to store the group id, which is key

import {createSlice} from '@reduxjs/toolkit';
import {mmkvStorage} from '../../Utils/mmkvStorage';

const initialState = {
  info: false, // use false insteaed of null - null will override default values and cause crashes
  userId: null, //used for creating the listener
  loggedIn: false,
  currentScavengerHuntGroupId: null,
  currentBarHuntGroupId: null,
};

const userInfoSlice = createSlice({
  name: 'user_info',
  initialState,
  reducers: {
    saveUserInfo(state, {payload: info}) {
      console.log('saveUserInfo');
      state.info = info;
      state.userId = info?.userId;
      state.loggedIn = true;
    },
    logOutUser(state) {
      console.log('Logging out user');
      mmkvStorage.delete('userId');
      mmkvStorage.delete('userInfo');
      state.info = null;
      state.userId = null;
      state.loggedIn = false;
    },
    setCurrentGroupId(state, {payload: currentGroupId}) {
      console.log('setCurrentGroupId - ' + currentGroupId);
      state.currentGroupId = currentGroupId;
    },
  },
});

export const {saveUserInfo, logOutUser, setCurrentGroupId} =
  userInfoSlice.actions;

export default userInfoSlice.reducer;
